/*
 * @Description: 
 * @Version: 1.0
 * @Autor: zhangle
 * @Date: 2022-05-25 14:40:48
 * @LastEditors: zhangle
 * @LastEditTime: 2022-05-30 09:38:39
 */
/**
 * 读取cookies
 */
 export const getCookie = (name) => {
    let arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg)) return (arr[2]);
    else return null;
};

/**
 * 控制 body 滚动锁定（多组件安全）
 * 通过 body-hidden class 统一管理，避免多个弹窗组件互相覆盖 overflow
 * @param {boolean} hidden - true 锁定滚动，false 释放滚动
 */
let bodyHiddenCount = 0;
export const setBodyOverflow = (hidden) => {
    if (hidden) {
        bodyHiddenCount++;
        if (!document.body.classList.contains('body-hidden')) {
            document.body.classList.add('body-hidden');
        }
    } else {
        bodyHiddenCount = Math.max(0, bodyHiddenCount - 1);
        if (bodyHiddenCount === 0) {
            // 计数归零，去除 body-hidden 并清空 overflow
            document.body.classList.remove('body-hidden');
            document.body.style.overflow = '';
        }
        // bodyHiddenCount > 0 说明其他组件仍在使用，不做任何操作
    }
};



// WEBPACK FOOTER //
// ./src/js/utils.js